/**
 * Outlined circular cross icon (circle with an "X").
 *
 * @param props.width - SVG width (defaults to `24`).
 * @param props.height - SVG height (defaults to `24`).
 * @param props.stroke - Stroke color for the glyph (defaults to orange `#EF6C00`).
 * @returns The rendered cross circle SVG icon.
 */
const CrossCircleIcon = (props: {
  width?: string;
  height?: string;
  stroke?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "24"}
    height={props.height || "24"}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M15 9L9 15M9 9L15 15M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      stroke={props.stroke || "#EF6C00"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CrossCircleIcon;
